import React, { useContext, useEffect, useState } from "react";
//import "./safetyforms/safetyforms.css";
import { FaChevronDown, FaChevronRight, FaFolder, FaFolderPlus, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import styled from "styled-components";
import theme from "../common/theme";
import { BlackButton, ButtonBase, WhiteButton } from "./Buttons";
import Modal, { ModalDivider } from "./Modal";
import Row from "./Row";
import { StyledSearch } from "./Search";
import { EmptyTab, Tab, TabContainer, TabContext } from "./Tabs";
import { H1, P, P2 } from "./Typography";
import { fetchFolders, selectFolders, selectFoldersByParentId } from "../common/slices/folder";
import ModalNewFolder from "./ModalNewFolder";
import { modifyDocument } from "../common/slices/document";
import { ErrorContext } from "../ErrorContext";

const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
`

const FolderContainer = styled(Row)`
    padding: 1rem;
    border-bottom: 1px solid ${theme.palette.border};
    background-color: ${props => props.active ? theme.palette.light : 'none'};
    cursor: pointer;

    &:hover {
        background-color: ${theme.palette.border};
    }
`

const NestedFolders = styled.div`
    padding-left: 1rem;
`

const Folder = ({ activeFolder, folder, onClick }) => {
    const [expanded, setExpanded] = useState(false);
    return (
        <>
            <FolderContainer active={folder?.id === activeFolder?.id} onClick={() => {
                setExpanded(!expanded)
                onClick(folder);
            }}>
                <P style={{ flex: 1, color: '#000' }}>{folder.name}</P>
                {
                    expanded ?
                        <FaChevronDown color="#000" />
                        : <FaChevronRight color="#000" />
                }
            </FolderContainer>
            {expanded && <NestedFolders><FolderList activeFolder={activeFolder} parentId={folder.id} onClick={onClick} /></NestedFolders>}
        </>
    )
}

const FolderList = ({ activeFolder, parentId, onClick }) => {
    const dispatch = useDispatch();

    const folders = useSelector(selectFoldersByParentId(parentId));

    useEffect(() => {
        console.log('dispatch fetch folder list with parent', parentId);
        dispatch(fetchFolders(parentId));
    }, [parentId])

    if (!folders?.length) {
        return null;
    }

    return (
        folders?.map(folder => <Folder activeFolder={activeFolder} key={folder.id} folder={folder} onClick={onClick} />)
    )
}

const ModalMoveDocument = ({ document, onClose }) => {
    const errorContext = useContext(ErrorContext);
    const dispatch = useDispatch();
    const rootFolders = useSelector(selectFoldersByParentId("root"));
    const [selectedFolder, setSelectedFolder] = useState(null);
    const [showNewFolder, setShowNewFolder] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                await dispatch(fetchFolders("root"));
            } catch (ex) {
                errorContext.setError({ errorMessage: "Failed to load root folders", forSupport: ex.message });
            }

        })();
    }, [])

    const onSubmit = async () => {
        try {
            await dispatch(modifyDocument({ id: document.id, folderId: selectedFolder.id }))
            onClose();
        } catch (ex) {
            errorContext.setError({ errorMessage: "Failed to move document to folder", forSupport: ex.message });
        }
    };

    return (
        <Modal show size="65%">
            <Row>
                <H1>Move form</H1>
                <ButtonBase onClick={onClose} style={{ marginLeft: 'auto' }}><FaTimes size='16px' color="#000" /></ButtonBase>
            </Row>
            <ModalDivider />

            <Content>
                <P2>Current location</P2>
                <Row>
                    <FaFolder size='18px' />
                    <P style={{ color: "#000" }}>{document?.folder?.name}</P>
                </Row>
                <P style={{ color: theme.palette.dark }}>{document?.folder?.path}</P>
            </Content>

            {/* <StyledSearch /> */}

            <TabContainer initialTab={rootFolders?.[0]?.id}>
                <Row>
                    {rootFolders?.map(folder => <Tab key={folder.id} tabId={folder.id} onClick={() => setSelectedFolder(folder)}>{folder.name}</Tab>)}
                    <EmptyTab />
                </Row>

                <TabContext.Consumer>
                    {(context) => (
                        <FolderList parentId={context.active} onClick={(folder) => setSelectedFolder(folder)} activeFolder={selectedFolder} />
                    )}
                </TabContext.Consumer>
            </TabContainer>



            <Content>
                <P2>New location</P2>
                {
                    selectedFolder ?
                        <>
                            <Row>
                                <FaFolder size='18px' />
                                <P style={{ color: "#000" }}>{selectedFolder.name}</P>
                            </Row>
                            <P style={{ color: theme.palette.dark }}>{selectedFolder.path}</P>
                        </>
                        : <P>Select a new location above</P>
                }
            </Content>


            <Row>
                <WhiteButton onClick={() => setShowNewFolder(true)} style={{ flex: 1 }} disabled={!selectedFolder}>Add new folder <FaFolderPlus size="18px" /></WhiteButton>
                <BlackButton onClick={onSubmit} style={{ flex: 1 }} disabled={!selectedFolder}>Save</BlackButton>
            </Row>
            {showNewFolder && <ModalNewFolder parent={selectedFolder} onClose={() => setShowNewFolder(false)} />}
        </Modal>
    );
};

export default ModalMoveDocument;
